<template>
    <div id="webix-box">
        <div id="box" style="height:500px;"></div>
    </div>
</template>

<script>

export default {
    name: "webix-filemanager",
    props: ['folders', 'team_id', 'user_id', 'clean', 'project', 'isPm', 'stack', 'companyCam', 'folder', 'projectName'],

    data() {
        return {
            csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        };
    },

    created() {
        this.fileManager();
    },

    methods: {
        customRefresh() {
            document.getElementById('box').innerHTML = '';
            document.getElementById('webix-box').innerHTML = '<div id="box" style="height:500px;"></div>';
        },
        fileManager() {
            const self = this;
            webix.ready(function() {
                if (webix.env.mobile) webix.ui.fullScreen();
                webix.CustomScroll.init();
                class MyBackend extends fileManager.services.Backend {
                    folders(id) {
                        let projectId = null;
                        if(self.project) {
                            projectId = self.project;
                        }
                        let payload = {
                            id,
                            projectId,
                        };
                        return webix.ajax(route('api.webix.file-manager.folders'), payload).then(res => res.json());
                    }
                    makedir(id, name) {
                        let projectId = null;
                        if(self.project) {
                            projectId = self.project;
                        }
                        let payload = {
                            id,
                            name,
                            projectId,
                            _token: self.csrfToken
                        };
                        return webix.ajax().post(route('api.webix.file-manager.add.folder'), payload).then((res) => {
                            self.customRefresh();
                            webix.ui({
                                view: "filemanager",
                                container:"box",
                                url: 'http://127.0.0.1:8000/api/webix/file-manager/',
                                override: new Map([[fileManager.services.Backend, MyBackend]]),
                            });
                        });
                    }
                    rename(id, name, type) {
                        return webix.ajax().post(route('api.webix.file-manager.rename.folder'), {
                            id,
                            name,
                            _token: self.csrfToken
                        }).then((res) => {
                            self.customRefresh();
                            webix.ui({
                                view: "filemanager",
                                container:"box",
                                url: 'http://127.0.0.1:8000/api/webix/file-manager/',
                                override: new Map([[fileManager.services.Backend, MyBackend]]),
                            });
                        });
                    }
                    remove(id) {
                        return webix.ajax().post(route('api.webix.file-manager.delete.folder'), {
                            id,
                            _token: self.csrfToken
                        }).then((res) => {
                            self.customRefresh();
                            webix.ui({
                                view: "filemanager",
                                container:"box",
                                url: 'http://127.0.0.1:8000/api/webix/file-manager/',
                                override: new Map([[fileManager.services.Backend, MyBackend]]),
                            });
                        });
                    }
                    files(id) {
                        let projectId = null;
                        if(self.project) {
                            projectId = self.project;
                        }
                        let payload = {
                            id,
                            projectId,
                        };
                        return webix.ajax(route('api.webix.file-manager.files'), payload)
                                    .then(res => res.json());
                    }
                    icon(type, size) {
                        //serve image/jpg for all icons
                        return `https://docs.webix.com/filemanager-backend/icons/${size ||
                        "small"}/image/jpg.svg`;
                    }
                    getInfo() {
                        return Promise.resolve({
                            stats:{
                                free: 52 * 1000 * 1000,
                                total: 250 * 1000 * 1000,
                                used: 198.4 * 1000 * 1000,
                            }
                        });
                    }
                }
                webix.ui({
                    view: "filemanager",
                    container:"box",
                    url: 'http://127.0.0.1:8000/api/webix/file-manager/',
                    override: new Map([[fileManager.services.Backend, MyBackend]]),
                });
            });
        },
        getFolders() {
            console.log('aaabccc');
        }
    },
}
</script>

<style scoped>

</style>
